import { useState } from 'react';
import * as THREE from 'three';
import { make3DModelTransparentAndRed } from '../../../utils/make-3d-model-transparent-and-red/make-3d-model-transparent-and-red';

type TransparentModelProps = {
    uuid: string;
    position: THREE.Vector3Tuple;
    rotation: THREE.EulerTuple;
    model: THREE.Object3D;
};

export const TransparentModel = ({ uuid, position, rotation, model }: TransparentModelProps) => {
    const [prevModel, setPrevModel] = useState<typeof model>();

    if (model !== prevModel) {
        setPrevModel(model);

        if (!model) return null;

        make3DModelTransparentAndRed(model);
    }

    return (
        <group
            uuid={uuid}
            position={position}
            rotation={rotation}
            frustumCulled={false}
        >
            { model && <primitive object={model} /> }
        </group>
    );
};